import { Box, Stack } from "@mui/material";
import React from "react";
import { ReactComponent as FacebookIcon } from "../../../../assets/facebookIcon.svg";
import { ReactComponent as YoutubeIcon } from "../../../../assets/youtubeIcon.svg";
import { ReactComponent as LinkedinIcon } from "../../../../assets/linkedinIcon.svg";
import { ReactComponent as InstagramIcon } from "../../../../assets/instagramIcon.svg";
import { Link } from "react-router-dom";

export const FooterHeader: React.FC = () => {
  return (
    <Box
      marginX={4}
      display="flex"
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <img
        decoding="async"
        width="224"
        height="63"
        alt="Davey Water Logo"
        src="https://daveywater.com/au/wp-content/uploads/sites/2/2022/11/davey-logo-01.png"
        sizes="(max-width: 900px) 100vw, 224px"
      />
      <Stack flexDirection={"row"} gap={4}>
        <Box
          width={40}
          height={40}
          sx={{ background: "#545454" }}
          border={"1px solid #A4A4A4"}
          borderRadius={2}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Link
            style={{ textDecoration: "none", display: "flex" }}
            to="https://www.facebook.com/DaveyWaterProducts/"
          >
            <FacebookIcon width={20} height={20} />
          </Link>
        </Box>
        <Box
          width={40}
          height={40}
          sx={{ background: "#545454" }}
          border={"1px solid #A4A4A4"}
          borderRadius={2}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Link
            style={{ textDecoration: "none", display: "flex" }}
            to="https://www.instagram.com/davey_pools/"
          >
            <InstagramIcon width={20} height={20} />
          </Link>
        </Box>
        <Box
          width={40}
          height={40}
          sx={{ background: "#545454" }}
          border={"1px solid #A4A4A4"}
          borderRadius={2}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Link
            style={{ textDecoration: "none", display: "flex" }}
            to="https://www.youtube.com/user/DaveyWaterProducts"
          >
            <YoutubeIcon width={20} height={20} />
          </Link>
        </Box>
        <Box
          width={40}
          height={40}
          sx={{ background: "#545454" }}
          border={"1px solid #A4A4A4"}
          borderRadius={2}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Link
            style={{ textDecoration: "none", display: "flex" }}
            to="https://www.linkedin.com/company/davey-water-products/"
          >
            <LinkedinIcon width={20} height={20} />
          </Link>
        </Box>
      </Stack>
    </Box>
  );
};
